import { c as _c } from "react/compiler-runtime";
import { Box, Skeleton, Stack } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button } from '@/components/form/baseInputs/Button';
import { EditButton } from '@/components/form/baseInputs/Button/EditButton';
import { DataTable_LEGACY } from '@/components/tables/DataTable_LEGACY/DataTable_LEGACY';
import { Column } from '@/components/tables/DataTable_LEGACY/tableTypes';
import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';
import { SPACING_CONSTANT } from '@/styles/themes/common';
import { formatCurrency } from '@/utils/formatting/currency';
import { getAssetCategoryDisplay } from '../assetCategoryUtils';
import { AssetDetailsModal, AssetDetailsModalProps } from '../AssetDetailsModal/AssetDetailsModal';
import { SubformAsset } from '../AssetsSubform/types';
import { Asset, NEW_ASSET_ID } from '../types/asset';
import { getAssetCellDefinition, getMarketValueForAsset, getSelectedAsset } from '../utils';
const COLUMNS: Column[] = [{
  field: 'asset',
  headerName: 'Asset',
  width: 130,
  sortable: false,
  flex: 1
}, {
  field: 'totalMarketValue',
  headerName: 'Total market value',
  width: 180,
  sortable: false
}, {
  field: 'action',
  headerName: '',
  width: 110,
  sortable: false,
  align: 'right'
}];
function getValidAssets(rowItems: SubformAsset[]): SubformAsset[] {
  if (!rowItems) return [];
  return rowItems.filter(rowItem => !rowItem.doDelete);
}
interface Props {
  assetList: SubformAsset[];
  removeByAsset: (value: Asset) => void;
  updateByAsset: (value: Asset) => void;
  loading?: boolean;
  disabled?: boolean;
  updateAssetButtonText?: string;
  isInitialValuation: boolean;
}
export function AssetFormTable(t0) {
  const $ = _c(26);
  const {
    assetList,
    removeByAsset,
    updateByAsset,
    disabled,
    loading,
    updateAssetButtonText: t1,
    isInitialValuation
  } = t0;
  const updateAssetButtonText = t1 === undefined ? "Update" : t1;
  const {
    assetClassesById
  } = useTenantDetailsContext();
  const undeletedAssets = getValidAssets(assetList);
  const [timedOut, setTimedOut] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getSelectedAsset([], NEW_ASSET_ID);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [selectedAsset, setSelectedAsset] = useState(t2);
  const [initialAssets, setInitialAssets] = useState(null);
  useEffect(() => {
    if (initialAssets === null && undeletedAssets.length > 0) {
      setInitialAssets(undeletedAssets);
    }
  }, [undeletedAssets, setInitialAssets, initialAssets]);
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setTimeout(() => {
        setTimedOut(true);
      }, 250);
    };
    t4 = [];
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] !== disabled || $[4] !== isInitialValuation || $[5] !== setIsModalOpen || $[6] !== updateAssetButtonText) {
    t5 = (confirmedAsset, asset) => <>{confirmedAsset && isInitialValuation ? <EditButton disabled={disabled} data-testid="EditAssetButton" onClick={() => {
        setSelectedAsset(asset);
        setIsModalOpen(true);
      }} /> : <Button variant="primary" data-testid="EditAssetButton" size="xs" disabled={disabled} onClick={() => {
        setSelectedAsset(asset);
        setIsModalOpen(true);
      }}>{updateAssetButtonText}</Button>}</>;
    $[3] = disabled;
    $[4] = isInitialValuation;
    $[5] = setIsModalOpen;
    $[6] = updateAssetButtonText;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const renderAction = t5;
  let t6;
  if ($[8] !== assetClassesById || $[9] !== renderAction) {
    t6 = undeletedAssets_0 => undeletedAssets_0.map(asset_0 => {
      const confirmedAsset_0 = asset_0.confirmed;
      return {
        id: asset_0.id,
        asset: getAssetCellDefinition({
          displayName: asset_0.displayName,
          displayCategory: getAssetCategoryDisplay(asset_0, assetClassesById)
        }),
        totalMarketValue: <Box sx={{
          opacity: `${confirmedAsset_0 ? "1" : "0.5"}`
        }}>{formatCurrency(getMarketValueForAsset(asset_0))}</Box>,
        action: renderAction(confirmedAsset_0, asset_0)
      };
    });
    $[8] = assetClassesById;
    $[9] = renderAction;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const makeRows = t6;
  const rows = makeRows(undeletedAssets);
  let t7;
  if ($[11] !== removeByAsset || $[12] !== setIsModalOpen || $[13] !== updateByAsset) {
    t7 = (value, t8) => {
      const {
        isRemoveAsset
      } = t8;
      if (isRemoveAsset) {
        removeByAsset(value);
      } else {
        updateByAsset(value);
      }
      setIsModalOpen(false);
    };
    $[11] = removeByAsset;
    $[12] = setIsModalOpen;
    $[13] = updateByAsset;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleAssetsModalSubmit = t7;
  if (loading && timedOut) {
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Stack spacing={1} pb={5}><Skeleton variant="rectangular" width="100%" height={SPACING_CONSTANT * 10} /><Skeleton variant="rectangular" width="100%" height={SPACING_CONSTANT * 10} /></Stack>;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  let t8;
  if ($[16] !== handleAssetsModalSubmit || $[17] !== isModalOpen || $[18] !== selectedAsset || $[19] !== setIsModalOpen) {
    t8 = isModalOpen && <AssetDetailsModal onSubmit={handleAssetsModalSubmit} asset={selectedAsset} isOpen={isModalOpen} isNewAsset={false} onClose={() => setIsModalOpen(false)} />;
    $[16] = handleAssetsModalSubmit;
    $[17] = isModalOpen;
    $[18] = selectedAsset;
    $[19] = setIsModalOpen;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== rows) {
    t9 = <DataTable_LEGACY columns={COLUMNS} rows={rows} variant="long" hideFooter_DANGEROUS_ONLY_GOES_TO_100_ITEMS={true} />;
    $[21] = rows;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}